var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { COMALL_ELEMENT_TYPE } from './CoMallSymbols';
import { CheckType, checkType } from './shared';
/**
 * 创建并返回一个 CoMallElement
 * @param type
 * @param props
 * @param children
 */
function createCoMallElement(type, props, ...children) {
    const element = Object.create(null);
    element['$$typeof'] = COMALL_ELEMENT_TYPE;
    element['type'] = type;
    element['props'] = {};
    if (props && checkType(props) === CheckType.Object) {
        const { key } = props, other = __rest(props, ["key"]);
        element['key'] = key ? key : null;
        element['props'] = Object.assign({}, other);
    }
    if (children && children.length > 0) {
        const preProps = element['props'];
        element['props'] = Object.assign({ children }, preProps);
    }
    return element;
}
export default createCoMallElement;
//# sourceMappingURL=createCoMallElement.js.map